const drawerWidth = 270;
const styles = theme => ({
  root: {
    width: '100%',
    height: '100%',
    marginTop: 0,
    zIndex: 1,
    overflow: 'hidden',
    display:'flex'
  },
  appFrame: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/styles.js